import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './Placeholder.css';
import * as actionTypes from '../../store/actions';

class Placeholder extends Component {

  state = {
    indexToRegion: {
      1 : "ЛЬВІВ",
      2 : "ВІННИЦЯ",
      3 : "КИЇВ",
      4 : "ХАРКІВ",
      5 : "ДНІПРО",
      6 : "ОДЕСА",
      7 : "ІМПОРТ"
    }
  }

  dragOverHandler = (event) => {
    this.props.onDragOver(-1);
  }

  render() {
    let placeholderClasses = [classes.Placeholder];
    if (this.props.dragInitialData.origin !== null &&
       this.state.indexToRegion[this.props.locations[this.props.dragInitialData.origin].region] === this.props.origin &&
        this.state.indexToRegion[this.props.locations[this.props.dragInitialData.destination].region] === this.props.destination) {
      placeholderClasses.push(classes.Visible);
    }

    return (
      <div
        className={placeholderClasses.join(' ')}
        onDragOver={this.dragOverHandler} >
        Добавить Заявку
      </div>
    );
  }
};

const mapStateToProps = state => {
  return {
    dragInitialData: state.dragInitialData,
    dragOver: state.dragOver,
    locations: state.locations
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onDragOver: (dragOverObj) => dispatch({ type: actionTypes.DRAG_OVER_OBJ,
                                            dragOverObj: dragOverObj })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Placeholder);



// WEBPACK FOOTER //
// ./src/containers/Placeholder/Placeholder.js